var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRulerPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93836 22H4.06164C3.47531 22 3 21.5779 3 21.0572V20.75H6.5C6.91421 20.75 7.25 20.4142 7.25 20C7.25 19.5858 6.91421 19.25 6.5 19.25H3V16.75H5C5.41421 16.75 5.75 16.4142 5.75 16C5.75 15.5858 5.41421 15.25 5 15.25H3V12.75H6.5C6.91421 12.75 7.25 12.4142 7.25 12C7.25 11.5858 6.91421 11.25 6.5 11.25H3V8.75H5C5.41421 8.75 5.75 8.41421 5.75 8C5.75 7.58579 5.41421 7.25 5 7.25H3V4.75H6.5C6.91421 4.75 7.25 4.41421 7.25 4C7.25 3.58579 6.91421 3.25 6.5 3.25H3V2.94281C3 2.42211 3.47531 2 4.06164 2H9.93836C10.5247 2 11 2.42211 11 2.94281V21.0572C11 21.5779 10.5247 22 9.93836 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2C15.8954 2 15 2.89543 15 4V5.25H21V4C21 2.89543 20.1046 2 19 2H17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.75H15V15.8197C15 16.5959 15.1807 17.3615 15.5279 18.0557L17.2764 21.5528C17.4134 21.8269 17.6936 22 18 22C18.3064 22 18.5866 21.8269 18.7236 21.5528L20.4721 18.0557C20.8193 17.3615 21 16.5959 21 15.8197V6.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerPencil);
export default __webpack_public_path__ + "static/media/ruler-pencil.760c232d43fada4e72c6b857c7f9c65a.svg";
export { ForwardRef as ReactComponent };